import { FaFacebookF, FaTwitter, FaLinkedinIn, FaInstagram, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
import LogoNav from '../image/logo_nav.png';
import Swal from 'sweetalert2';
import { useEffect, useState } from 'react';
import Backend from "../Backend/Backend";

export default function Footer() {

    const [loading, setLoading] = useState(false);

    const [backend, setBackend] = useState(null);

    const [email, setEmail] = useState("");


    // ✅ Init backend
    useEffect(() => {
        const initBackend = async () => {
            const b = await new Backend().init();
            setBackend(b);
        };
        initBackend();
    }, []);


    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!backend) return;

        setLoading(true);

        // ✅ Show loading popup
        Swal.fire({
            title: 'Sending...',
            text: 'Please wait',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        try {

            const data = {
                email: email
            }

            const res = await backend.subscribe(data);

            Swal.close(); // ✅ close loader

            if (res.error === "False") {
                Swal.fire({
                    icon: 'success',
                    title: 'Success',
                    text: 'Subscribed Successfully 🚀',
                    timer: 2000,
                    showConfirmButton: false
                });

                setEmail("")

            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Failed',
                    text: res.message || 'Failed to send ❌',
                });
            }

        } catch (err) {
            console.error(err);

            Swal.close();

            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Something went wrong ❌',
            });
        } finally {
            setLoading(false);
        }
    };

    const openInsta = () => {
        window.open(
            "https://www.instagram.com/gbtechnologiesinc?igsh=NHg2MWN3aXF5NHdw&utm_source=qr",
            "_blank"
        );
    };

    const openLinkedIn = () => {
        window.open(
            "https://www.linkedin.com/", // 👈 put your real LinkedIn page here
            "_blank"
        );
    };

    return (
        <footer className="bg-brand-dark text-gray-300 pt-20 pb-10 px-6 relative overflow-hidden border-t border-white/5">
            {/* Background Decorative Elements */}
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-[1px] bg-gradient-to-r from-transparent via-brand-accent/50 to-transparent"></div>
            <div className="absolute -top-24 -left-24 w-64 h-64 bg-brand-accent/10 rounded-full blur-[100px]"></div>

            <div className="relative max-w-7xl mx-auto">
                {/* Main Content Grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">

                    {/* Brand Column */}
                    <div className="space-y-6">
                        <div className="flex items-center gap-3">
                            <img src={LogoNav} alt="logo" className="h-10 w-auto" />
                            <h2 className="text-2xl font-bold text-white tracking-tight">
                                Genius
                                <span className="bg-brand-gradient bg-clip-text text-transparent"> Bridge Technologies</span>
                            </h2>
                        </div>
                        <p className="text-gray-400 leading-relaxed max-w-xs">
                            Empowering brands with cutting-edge digital architecture and seamless user experiences.
                        </p>
                        <div className="flex gap-3">
                            {[
                                { icon: FaLinkedinIn, action: openLinkedIn },
                                { icon: FaInstagram, action: openInsta }
                            ].map((item, index) => {
                                const Icon = item.icon;
                                return (
                                    <button
                                        key={index}
                                        onClick={item.action}
                                        className="p-2.5 rounded-lg bg-white/5 border border-white/10 hover:border-brand-accent/50 hover:bg-brand-gradient transition-all duration-300 group"
                                    >
                                        <Icon size={18} className="group-hover:text-white transition-colors" />
                                    </button>
                                );
                            })}
                        </div>
                    </div>

                    {/* Services Column */}
                    <div>
                        <h3 className="text-white font-bold text-lg mb-6">Our Services</h3>
                        <ul className="space-y-4 text-sm">
                            {['Resume Optimization', 'Interview Training', 'Job Placement', 'Software & App Development', 'Cloud & DevOps Solutions', 'Cybersecurity & Compliance'].map((item) => (
                                <li key={item}>
                                    <a href="#services" className="hover:text-brand-accent flex items-center gap-2 transition-all group">
                                        <span className="w-0 group-hover:w-2 h-[1px] bg-brand-accent transition-all"></span>
                                        {item}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Contact Info Column */}
                    <div>
                        <h3 className="text-white font-bold text-lg mb-6">Contact Us</h3>
                        <ul className="space-y-4 text-sm">
                            <li className="flex items-start gap-3">
                                <FaMapMarkerAlt className="mt-1 text-brand-accent" />
                                <span>30 N Gould St Ste R,<br />Sheridan WY 82801</span>
                            </li>
                            <li className="flex items-center gap-3">
                                <FaEnvelope className="text-brand-accent" />
                                <a href="mailto:info@geniusbridgetech.com" className="hover:text-white transition">info@geniusbridgetech.com</a>
                            </li>
                        </ul>
                    </div>

                    {/* Newsletter Column */}
                    <div>
                        <h3 className="text-white font-bold text-lg mb-6">Stay Updated</h3>
                        <p className="text-sm text-gray-400 mb-4">Subscribe to get the latest tech insights.</p>
                        <form className="flex flex-col gap-2">
                            <input
                                type="email"
                                value={email}
                                placeholder="Enter your email"
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                className="bg-white/5 border border-white/10 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:border-brand-accent transition"
                            />
                            <button
                                disabled={loading}
                                onClick={handleSubmit}
                                className="bg-brand-gradient text-white font-semibold py-2.5 rounded-lg text-sm hover:opacity-90 transition shadow-lg shadow-brand-accent/20">
                                Subscribe
                            </button>
                        </form>
                    </div>
                </div>

                {/* Bottom Bar */}
                <div className="pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-6">
                    <div className="flex flex-wrap justify-center gap-6 text-xs font-medium uppercase tracking-widest text-gray-500">
                        <a href="#" className="hover:text-brand-accent transition">Privacy Policy</a>
                        <a href="#" className="hover:text-brand-accent transition">Terms of Service</a>
                        <a href="#" className="hover:text-brand-accent transition">Cookies</a>
                    </div>

                    <div className="text-center md:text-right">
                        <p className="text-sm text-gray-400">
                            © {new Date().getFullYear()} <span className="text-white font-medium">Genius Bridge Technologies </span>.
                        </p>
                        <p className="text-[10px] text-gray-600 mt-1 uppercase tracking-wider">
                            Crafted & Engineered in Sheridan, Wyoming, USA
                        </p>
                    </div>
                </div>
            </div>
        </footer>
    );
}